import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const ChevronIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '35%' : '50%'}
      height={circled ? '35%' : '50%'}
      viewBox="0 0 11.687 6.904"
    >
      <g transform="translate(1.061 1.061)">
        <path
          d="M197.911,26l4.783,4.783L207.477,26"
          transform="translate(-197.911 -26)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
